import React from 'react';
import ReactSpeedometer from "react-d3-speedometer";
import './meter-graph.css'


class MeterGraph extends React.Component {
    state = {
        windowHeight: undefined,
        windowWidth: undefined,
        firstLoad: true
    }

    handleResize = () => this.setState({
        windowHeight: window.innerHeight,
        windowWidth: window.innerWidth
    });

    componentDidMount() {
        this.handleResize();
        window.addEventListener('resize', this.handleResize)
        setTimeout(() => {
            this.setState({ firstLoad: false })
        }, 1000);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize)
    }

    value = 50

    render() {
        return (
            <div className="meter-graph-container">
                <div className="meter-graph-header">
                    <span>{this.props.title}</span>
                </div>
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '300px' }}>

                    <ReactSpeedometer
                        value={this.props.data.value > 100 ? 100 : this.props.data.value}
                        currentValueText={this.props.data.label}
                        maxValue={100}
                        segments={10}
                        height={175}
                        // startColor="#FFB300"
                        // endColor="#ff7700"
                        startColor="red"
                        endColor="lime"
                        needleHeightRatio={0.6}
                        forceRender={true}
                        textColor={'var(--txt-color)'}
                        needleColor={'var(--txt-color)'}

                    />
                </div>
            </div>

        )
    }
}

export default MeterGraph
